import { Checkbox } from "primereact/checkbox"
import { InputNumber } from "primereact/inputnumber"
import { Message } from "primereact/message"
import PropTypes from "prop-types"
import gpraStyles from "../../../../../styles/Participant-GPRA.module.css"
import { updateState } from "../../../utils/utils"

const MentalRow = (props) => {
  const {
    num,
    setNum,
    numError,
    numErrorType,
    disabled,
    removeError,
    legend,
    refused,
    setRefused,
    entity,
    setEntity,
    defaultZero,
    required
  } = props
  return (
    <div className={gpraStyles.mentalRowContainer}>
      <div className={gpraStyles.mentalRowLabel}>
        <label className={gpraStyles.ml1}>{legend}{required && <span className={gpraStyles.required}> *</span>}</label>
      </div>
      <div>
        <InputNumber
          className={gpraStyles.inputNumber}
          inputClassName={numError && gpraStyles.numberError}
          value={!num && defaultZero ? 0 : num}
          onValueChange={(e) => {
            updateState(setNum, e.value, null, null, entity, setEntity, null)
            removeError(numErrorType)
          }}
          showButtons
          disabled={disabled || refused}
          suffix=" Days"
          min={0}
        />
      </div>
      <div className={!!numError ? gpraStyles.invalidCheckbox : gpraStyles.checkbox}>
        <Checkbox
          disabled={disabled}
          id="binary"
          checked={refused}
          onChange={(e) => {
            if (e.checked) {
              updateState(
                setRefused,
                e.checked,
                null,
                null,
                entity,
                setEntity,
                [{ key: setNum, value: 0 }]
              )
            } else {
              updateState(
                setRefused,
                e.checked,
                null,
                null,
                entity,
                setEntity,
                null
              )
            }
            removeError(numErrorType)
          }}
        />
        <label className={gpraStyles.ml1} htmlFor="binary">
          Refused
        </label>
      </div>
      <div className={gpraStyles.mentalErrorContainer}>
        {numError && <Message severity="error" text={numError} />}
      </div>
    </div>
  )
}
MentalRow.propTypes = {
  num: PropTypes.number,
  setNum: PropTypes.string,
  numError: PropTypes.string,
  numErrorType: PropTypes.string,
  disabled: PropTypes.bool,
  removeError: PropTypes.func,
  legend: PropTypes.string,
  refused: PropTypes.bool,
  setRefused: PropTypes.string,
}

export default MentalRow
